export default {
  beforeMount(el, binding) {
    const handleClickOutside = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event); // Call the function passed to the directive
      }
    };

    el.__clickOutsideEvent__ = handleClickOutside;
    document.addEventListener("mousedown", el.__clickOutsideEvent__);
  },
  unmounted(el) {
    document.removeEventListener("mousedown", el.__clickOutsideEvent__);
  },
};